import { useEffect } from "react";
import ProjectsWhiteSection from "../sections/ProjectsWhiteSection";
import ApplicationFormSection from "../sections/ApplicationFormSection";

const ProjectsPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="w-full">
      <ProjectsWhiteSection />
      <ApplicationFormSection />
    </div>
  );
};

export default ProjectsPage;

